import { render, staticRenderFns } from "./credit-bureau-container.vue?vue&type=template&id=0dfc1ff1"
import script from "./credit-bureau-container.vue?vue&type=script&lang=js"
export * from "./credit-bureau-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports